import taskList from './task-list';

export default taskList;
